import { Button, Grid, Input } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { applyPromoCode, setPromocode } from '~/store/legacy/actions/shoppingCartActions';
import {
  selectAllCartErrors,
  selectShoppingCartData,
} from '~/store/legacy/selector/shoppingCartSelectors';
import useStyles from './PromoCodeInput.style.js';
import classnames from 'classnames';

const PromoCodeInput = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { promoCode } = useSelector(selectShoppingCartData);

  const [error, setError] = useState(null);
  const cartErrors = useSelector(selectAllCartErrors);
  useEffect(() => {
    if (cartErrors.promoCode) {
      setError(cartErrors.promoCode);
    } else if (!cartErrors.promoCode && error) {
      setError(null);
    }
  }, [cartErrors.promoCode]);
  const errorClass = error ? classes.error : null;
  const promoClass = classnames(classes.promo, errorClass);
  const errorMessage = () => (error ? <p className={classes.errorText}>{error.message}</p> : null);

  return (
    <>
      <Grid item className={promoClass}>
        <Input
          fullWidth
          margin='none'
          name='promoCode'
          placeholder='Promo Code'
          disableUnderline={false}
          onChange={(e) => dispatch(setPromocode(e.target.value))}
          value={promoCode}
          style={{ fontFamily: 'proximanova-bold', background: '#ffffff' }}
          className={classes.field}
          endAdornment={
            <Button
              color='primary'
              onClick={() => dispatch(applyPromoCode())}
              disabled={!promoCode}
              variant='text'>
              Apply
            </Button>
          }
        />
      </Grid>
      {errorMessage()}
    </>
  );
};

export default PromoCodeInput;
